import { render, staticRenderFns } from "./CustomerAlsoBought.vue?vue&type=template&id=e2a017f0&scoped=true"
import script from "./CustomerAlsoBought.vue?vue&type=script&lang=js"
export * from "./CustomerAlsoBought.vue?vue&type=script&lang=js"
import style0 from "./CustomerAlsoBought.vue?vue&type=style&index=0&id=e2a017f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a017f0",
  null
  
)

export default component.exports